import { render, staticRenderFns } from "./CidadaosAcompanhadosChart.vue?vue&type=template&id=3636c714"
import script from "./CidadaosAcompanhadosChart.vue?vue&type=script&lang=js"
export * from "./CidadaosAcompanhadosChart.vue?vue&type=script&lang=js"
import style0 from "./CidadaosAcompanhadosChart.vue?vue&type=style&index=0&id=3636c714&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports